module.exports = __webpack_public_path__ + "img/who_whe_are.9525fd55.png";